import 'promise-polyfill/src/polyfill';

import './libraries/slimmageSettings';
import './libraries/slimmage';

// App
import App from './app';
import PolyfillController from './controllers/polyfill';

// Controllers
import HeaderController from './controllers/header';
import MediaController from './controllers/media';
// import AVGController from './controllers/avg';
import FormController from './controllers/form';
import ToastController from './controllers/toast/controller';
import SliderController from './controllers/slider';
import ParallaxController from './controllers/parallax';
// import HyphenController from './controllers/hyphen';

(async () => {
    document.querySelector('html').classList.remove('no-js');

    const polyfills = new PolyfillController();
    await polyfills.init();

    try {
        const app = new App();
        app.resizeThrottle = 10;
        app.scrollThrottle = 100;
        window.app = app;
    
        app.polyfillController = polyfills;
    
        // app.AVGController = new AVGController();
        app.headerController = new HeaderController();
        app.mediaController = new MediaController();
        app.formController = new FormController();
        app.toastController = new ToastController();
        app.sliderController = new SliderController();
        app.parallaxController = new ParallaxController();

        // Modules
        const loadModules = () => {
            if (document.querySelector('.shareContainer')) {
                import( /* webpackChunkName: "modules/share" */ './controllers/share/controller').then(e => {
                    app.shareController = new e.default();
                });
            }

            if (document.querySelector('[data-gallery]')) {
                import( /* webpackChunkName: "modules/gallery" */ './controllers/gallery').then(e => {
                    app.galleryController = new e.default();
                });
            }

            if (document.querySelector('.pagedOverview')) {
                import( /* webpackChunkName: "modules/overview" */ './controllers/pagedOverview').then(e => {
                    app.pagedOverviewController = new e.default(document.querySelector('.pagedOverview'));
                });
            }

            if (document.querySelector('.magazineOverview')) {
                import( /* webpackChunkName: "modules/pagedOverview" */ './controllers/magazineOverview').then(e => {
                    app.magazineOverviewController = new e.default();
                });
            }

            if (document.querySelector('.blMap')) {
                import( /* webpackChunkName: "modules/mapBlock" */ './controllers/mapBlock/controller').then(e => {
                    app.mapBlockController = new e.default();
                });
            }

            if (document.querySelector('.blAccordion')) {
                import( /* webpackChunkName: "modules/accordion" */ './controllers/accordion/controller').then(e => {
                    app.accordionController = new e.default();
                });
            }

            if (document.querySelector('section.blDonateForm')) {
                import( /* webpackChunkName: "modules/donateForm" */ './controllers/donateForm').then(e => {
                    app.donateFormController = new e.default();
                });
            }
        }

        loadModules();

        await app.init();
    } catch(e) {
        console.error(`Something went wrong initializing the app`);
        throw e;
    };

    console.log(`App initialized`);
    document.documentElement.classList.remove('preventAnimations');

})();